import antdEs from "antd/lib/locale-provider/es_ES";
import appLocaleData from "react-intl/locale-data/es";
import enMessages from "../locales/en_US.json";
import esMessages from "../locales/es_ES.json";

const EsLang = {
  messages: {
    ...enMessages,
    ...esMessages
  },
  antd: antdEs,
  locale: 'es',
  data: appLocaleData
};
export default EsLang;
